import { useState } from 'react';
import { Button, AritoIcon, DialogV2 } from '@/components/custom/erp';
import type { KenhBanHang } from '@/types/schemas';

interface DeleteDialogProps {
  open: boolean;
  onClose: () => void;
  selectedObj: KenhBanHang | null;
  onConfirmDelete: () => Promise<void>;
}

function DeleteDialog({ onClose, open, selectedObj, onConfirmDelete }: DeleteDialogProps) {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDelete = async () => {
    if (!selectedObj) return;

    setIsDeleting(true);
    setError(null);

    try {
      await onConfirmDelete();
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Có lỗi xảy ra khi xóa dữ liệu');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Xóa kênh bán hàng'
      maxWidth='lg'
      disableBackdropClose={true}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={260} />}
      actions={
        <>
          <Button
            className='bg-[rgba(15,118,110,0.9)] text-white hover:bg-[rgba(15,118,110,1)]'
            onClick={handleDelete}
            type='button'
            disabled={isDeleting}
          >
            <AritoIcon icon={884} marginX='4px' />
            {isDeleting ? 'Đang xử lý...' : 'Đồng ý'}
          </Button>
          <Button onClick={onClose} variant='outline' disabled={isDeleting}>
            <AritoIcon icon={885} marginX='4px' />
            Huỷ
          </Button>
        </>
      }
    >
      <div className='min-w-96 p-4'>
        <p className='text-base font-medium'>Bạn có chắc chắn muốn xóa?</p>
        {error && <p className='mt-2 text-red-600'>{error}</p>}
      </div>
    </DialogV2>
  );
}

export default DeleteDialog;
